import { useNavigate } from "react-router-dom";
import { useReveal } from "../hooks/useReveal";
import "./About.css";

export default function About({ data }) {
  const nav = useNavigate();
  const go = (page) => nav(page === "home" ? "/" : `/${page}`);

  const r1 = useReveal(), r2 = useReveal(), r3 = useReveal();
  const r4 = useReveal(), r5 = useReveal(), r6 = useReveal();

  const builders = [...(data?.partners?.builders || []), ...(data?.partners?.builders || [])];
  const funds    = [...(data?.partners?.funds    || []), ...(data?.partners?.funds    || [])];

  return (
    <div className="ab">

      {/* HERO */}
      <section className="ab-hero" style={{"--ab-bg":`url(${data?.hero?.bg})`}}>
        <div className="ab-hero-bg"/>
        <div className="ab-hero-accent"/>
        <div className="ab-hero-inner wrap">
          <div>
            <span className="ab-hero-tag">{data?.hero?.tag}</span>
            <h1 className="ab-hero-h1">
              {data?.hero?.h1?.map((line,i) => (
                <span key={i} className={line===data?.hero?.italic?"italic":""}>{line}<br/></span>
              ))}
            </h1>
          </div>
          <div className="ab-hero-right">
            <p className="ab-hero-p">{data?.hero?.body}</p>
            <div className="ab-hero-stats">
              {data?.hero?.stats?.map(s=>(
                <div className="ab-stat" key={s.label}>
                  <div className="ab-stat-v">{s.value}</div>
                  <div className="ab-stat-l">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* VISION + FOUNDER'S NOTE */}
      <section className="ab-vf" ref={r1}>
        <div className="ab-vf-inner wrap">
          <div className="ab-vision rv">
            <span className="ab-vf-tag">{data?.vision?.tag}</span>
            <blockquote className="ab-vision-q">"{data?.vision?.quote}"</blockquote>
          </div>
          <div className="ab-founder rv">
            <span className="ab-vf-tag">{data?.founder?.tag}</span>
            <blockquote className="ab-founder-q">"{data?.founder?.quote}"</blockquote>
            <cite className="ab-founder-cite">— Founder, PR Elite Estate</cite>
          </div>
        </div>
      </section>

      {/* STORY */}
      <section className="ab-story" ref={r2}>
        <div className="ab-story-inner wrap">
          <div className="ab-story-left rv2">
            <span className="ab-story-tag">{data?.story?.tag}</span>
            <h2 className="ab-story-h2">
              {data?.story?.h2?.map((line,i)=>(
                <span key={i} className={line.includes(data?.story?.italic)?"italic":""}>{line}{i<(data?.story?.h2?.length-1)?<br/>:""}</span>
              ))}
            </h2>
            <div className="ab-story-bar"/>
            <button className="btn btn-r" onClick={()=>go(data?.story?.cta?.page)}>{data?.story?.cta?.label}</button>
          </div>
          <div className="ab-story-right rv">
            {data?.story?.body?.map((p,i)=><p key={i}>{p}</p>)}
          </div>
        </div>
      </section>

      {/* WHAT MAKES US DIFFERENT */}
      <section className="ab-diff" ref={r3}>
        <div className="ab-diff-hd wrap">
          <span className="ab-diff-tag rv">{data?.differentiators?.tag}</span>
          <h2 className="ab-diff-h2 rv">{data?.differentiators?.h2}</h2>
        </div>
        <div className="ab-diff-grid wrap">
          {data?.differentiators?.items?.map(item=>(
            <div className="ab-diff-card rv" key={item.num}>
              <div className="ab-diff-num">{item.num}</div>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CORE SERVICES */}
      <section className="ab-core" ref={r4}>
        <div className="ab-core-hd wrap">
          <div>
            <span className="ab-core-tag rv">{data?.core?.tag}</span>
            <h2 className="ab-core-h2 rv">
              {data?.core?.h2?.map((line,i)=>(
                <span key={i}>{line}{i<(data?.core?.h2?.length-1)?<br/>:""}</span>
              ))}
            </h2>
          </div>
          <p className="ab-core-sub rv">{data?.core?.sub}</p>
        </div>
        <div className="ab-core-grid wrap">
          {data?.core?.items?.map(item=>(
            <div className="ab-core-card rv" key={item.num}>
              <div className="ab-core-num">{item.num}</div>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PARTNERS MARQUEES */}
      <section className="ab-partners" ref={r5}>
        <div className="ab-partners-hd">
          <span className="ab-partners-tag rv">{data?.partners?.tag}</span>
          <h2 className="ab-partners-h2 rv">{data?.partners?.buildersH2}</h2>
          <p className="ab-partners-p rv">{data?.partners?.buildersP}</p>
        </div>
        <div className="mq-wrap">
          <div className="mq-track mq-fwd">
            {builders.map((b,i)=><div className="mq-item" key={i}><img src={b.logo} alt={b.name} loading="lazy"/></div>)}
          </div>
        </div>
        <div className="ab-partners-divider">
          <span className="ab-partners-label">{data?.partners?.fundsLabel}</span>
        </div>
        <div className="mq-wrap" style={{marginTop:20}}>
          <div className="mq-track mq-bwd">
            {funds.map((f,i)=><div className="mq-item" key={i}><img src={f.logo} alt={f.name} loading="lazy"/></div>)}
          </div>
        </div>
      </section>

      {/* MANIFESTO */}
      <section className="ab-manifesto" ref={r6}>
        <div className="ab-manifesto-inner">
          <h2 className="ab-manifesto-h2 rv">
            {data?.manifesto?.split(". ").map((s,i,arr)=>(
              <span key={i} className="ab-mf-line">{s}{i<arr.length-1?".":""}</span>
            ))}
          </h2>
        </div>
      </section>

    </div>
  );
}
